<template>
  <div class="app-main-content">
    <div style="height: auto;width: 100%;margin-top: 5px;" class="cargo-advance-search price-air-stat">
      <div style="width: 100%">
        <div class="section form-row">
          <el-form
            label-position="left"
            label-width="85px"
            :inline="true"
          >
            <el-button no="toQuery" type="primary" @click="toQuery">
              {{ $t('Pricing.Statistics') }}
            </el-button>
            <el-button no="toReset" type="default" @click="toReset">
              {{ $t('Pricing.Reset') }}
            </el-button>
            <el-button no="exportExcel" type="default" @click="exportExcel">
              {{ $t('Pricing.Export') }}
            </el-button>
            <span style="margin-right: 20px;" />
            <el-form-item :label="$t('Pricing.Branch')">
              <cargo-office-select
                no="branchId"
                tag-name="code"
                tag-value="officeId"
                :office-id="!filter.branchId ? 0 : filter.branchId"
                @change="changeOffice"
              />
            </el-form-item>
            <el-form-item v-if="activeTabName !== 'gridPeriod'" :label="$t('Pricing.State')">
              <cargo-advance-select
                no="priceStates"
                :static-options="priceStates"
                tag-name="chineseName"
                tag-value="code"
                :clearable="false"
                :default-value="filter.state"
                @parentCallBack="changeState"
              />
            </el-form-item>
            <div v-if="activeTabName !== 'gridState'" style="display: flex">
              <el-form-item :label="statBeginDateName" style="margin-left: 10px">
                <el-radio-group v-model="filter.dateType" no="dateType">
                  <el-radio no="month" label="month">{{ $t('Pricing.Month') }}</el-radio>
                  <el-radio no="week" label="week">{{ $t('Pricing.Week') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-date-picker
                v-model="filter.dateFrom"
                no="dateFrom"
                type="date"
                style="width: 120px;"
                value-format="yyyy-MM-dd"
              />
              <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
              <el-date-picker
                v-model="filter.dateTo"
                no="dateTo"
                type="date"
                style="width: 120px;"
                value-format="yyyy-MM-dd"
              />
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="$t('Pricing.ByState')" name="gridState">
          <div class="section grid-wrapper">
            <cargo-ag-grid
              v-if="!showOffice"
              key="gridState"
              :grid-params.sync="gridStateGrid.gridParams"
              :grid-options="gridStateGrid.gridOptions"
              :column-defs="gridStateGrid.columnDefs"
              :row-data="gridStateGrid.rowData"
              :show-side-bar="false"
            />
            <cargo-ag-grid
              v-else
              key="officeGridState"
              :grid-params.sync="gridStateGrid.gridParams"
              :grid-options="gridStateGrid.officeGridOptions"
              :column-defs="gridStateGrid.columnDefs"
              :row-data="gridStateGrid.rowData"
              :show-side-bar="false"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('Pricing.ByDate')" name="gridPeriod">
          <div class="section grid-wrapper">
            <cargo-ag-grid
              v-if="!showOffice"
              key="gridPeriod"
              :grid-params.sync="gridPeriodGrid.gridParams"
              :grid-options="gridPeriodGrid.gridOptions"
              :column-defs="gridPeriodGrid.columnDefs"
              :row-data="gridPeriodGrid.rowData"
              :show-side-bar="false"
            />
            <cargo-ag-grid
              v-else
              key="officeGridPeriod"
              :grid-params.sync="gridPeriodGrid.gridParams"
              :grid-options="gridPeriodGrid.officeGridOptions"
              :column-defs="gridPeriodGrid.columnDefs"
              :row-data="gridPeriodGrid.rowData"
              :show-side-bar="false"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { PricingFCLConfigUtil } from '@/class/cargo/model/utils/PricingFCLConfigUtil'
import { getPriceAirStat } from '@/api/price/priceAir'
import DateUtils from '@/utils/dateUtils'
import * as ObjectUtil from '@/utils/commonUtil'
import StrUtils from '@/utils/StrUtils'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { sortByMultiFieldAndOrder } from '@/utils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'

export default {
  name: 'PriceAirStat',
  components: { CargoOfficeSelect, CargoAdvanceSelect },
  data() {
    return {
      filter: {
        state: '0',
        branchId: 0,
        dateType: 'month',
        dateFrom: '',
        dateTo: ''
      },
      showOffice: false,
      needMarkup: false,
      selectTypeNames: TYPE_NAMES,
      priceStates: PriceConstant.PRICE_STATES,
      activeTabName: 'gridState',
      gridStateGrid: {
        rowData: [],
        gridParams: {},
        gridApi: null,
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        officeGridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          treeData: true,
          context: {
            componentParent: this
          },
          getDataPath: data => {
            return (data.path || '').split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('Pricing.Branch'),
            field: 'branchId',
            colId: 'branchId',
            flex: 1,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              innerRenderer: (params) => {
                return ColumnUtils.officeLabelFormatFunc(params.value)
              }
            },
            valueFormatter: (params) => {
              return ColumnUtils.officeLabelFormatFunc(params.value)
            }
          }
        },
        columnDefs: [
          {
            headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', flex: 1,
            tooltipValueGetter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value,
                'englishName')
            }
          },
          {
            headerName: this.$t('Pricing.Level'), field: 'level', colId: 'level', flex: 1,
            hide: true,
            valueFormatter: (params) => {
              return PriceUtils.levelLabel(String(params.value))
            }
          },
          {
            headerName: this.$t('Pricing.TotalAmount'), field: 'amount', colId: 'amount', width: 200,
            flex: 1
          }
        ]
      },
      gridPeriodGrid: {
        rowData: [],
        gridParams: {},
        gridApi: null,
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        officeGridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          treeData: true,
          getDataPath: data => {
            return (data.path || '').split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('Pricing.Branch'),
            field: 'branchId',
            colId: 'branchId',
            hide: true,
            flex: 1,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              innerRenderer: (params) => {
                return ColumnUtils.officeLabelFormatFunc(params.value)
              }
            },
            valueFormatter: (params) => {
              return ColumnUtils.officeLabelFormatFunc(params.value)
            }
          }
        },
        columnDefs: [
          {
            headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', flex: 1,
            tooltipValueGetter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value,
                'englishName')
            }
          },
          {
            headerName: this.$t('Pricing.Level'), field: 'level', colId: 'level', flex: 1,
            valueFormatter: (params) => {
              return PriceUtils.levelLabel(String(params.value))
            }
          },
          {
            headerName: this.$t('Pricing.TotalAmount'), field: 'amount', colId: 'amount', width: 200, flex: 1
          }
        ]
      }
    }
  },
  computed: {
    statBeginDateName() {
      if (this.activeTabName === 'gridPeriod') {
        return this.$t('Pricing.StatBeginDateByDate')
      }
      if (this.activeTabName === 'gridPort') {
        return this.$t('Pricing.StatBeginDateByPort')
      }
      return ''
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    'filter.dateType': function(value) {
      this.initPeriod(value === 'month')
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const fclConfigUtil = await PricingFCLConfigUtil.getInstance()
      this.needMarkup = fclConfigUtil.needMarkup
      this.showOffice = MultiCompanyUtil.getInstance().isAdminOrHQ2('PriceFcl')
      this.initPeriod(true)
    },
    toQuery() {
      const params = {
        branchId: this.filter.branchId,
        type: this.activeTabName
      }
      if (this.activeTabName === 'gridState') {
        params['beginDate'] = this.filter.state === '0' ? '' : DateUtils.formatStandardDate(new Date())
        params['showLevel'] = this.filter.state !== '0' && this.needMarkup
        params['state'] = this.filter.state
      }
      if (this.activeTabName === 'gridPeriod') {
        const moreThan = ObjectUtil.dateCompare(this.filter.dateFrom, this.filter.dateTo) > 0
        params['showLevel'] = true
        params['dateFrom'] = moreThan ? this.filter.dateTo : this.filter.dateFrom
        params['dateTo'] = moreThan ? this.filter.dateFrom : this.filter.dateTo
      }
      getPriceAirStat(params).then(res => {
        if (!res.data || res.data.length === 0) {
          this.$message.warning(this.$t('Pricing.NoRecord'))
        }
        this.getGrid().rowData = this.sortData(res.data)
      })
    },
    getGrid() {
      if (this.activeTabName === 'gridState') {
        return this.gridStateGrid
      }
      if (this.activeTabName === 'gridPeriod') {
        return this.gridPeriodGrid
      }
    },
    // tab 页签点击事件
    handleTabClick(tab, event) {
      if (tab.name === this.activeTabName && this.$refs[this.activeTabName]) {
        this.$refs[this.activeTabName].fetchOrderRequirement()
      }
    },
    changeState(p) {
      this.filter.state = p.value
      const gridOptions = this.showOffice ? 'officeGridOptions' : 'gridOptions'
      this.gridStateGrid[gridOptions].columnApi.setColumnVisible('level', this.filter.state !== '0' && this.needMarkup)
      this.gridStateGrid.rowData = []
    },
    initPeriod(isMonthSelected) {
      const today = new Date()
      const day = isMonthSelected ? DateUtils.getMonthFirst() : DateUtils.getFirstDayOfWeek()
      this.filter.dateFrom = DateUtils.formatStandardDate(day)
      this.filter.dateTo = DateUtils.formatStandardDate(today)
    },
    exportExcel() {
      const fileName = this.getFileName()
      const grid = this.getGrid()
      const rows = grid.rowData
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        return
      }
      // 获取显示列
      const gridOptions = this.showOffice ? 'officeGridOptions' : 'gridOptions'
      const allDisplayedColumns = grid[gridOptions].columnApi.getAllDisplayedColumns()
      exportExcel(fileName, rows, [...allDisplayedColumns], false)
    },
    sortData(data) {
      return sortByMultiFieldAndOrder(data, { 'path': 'asc' })
    },
    getFileName() {
      const fileName = this.$t('Pricing.AirStatistics')
      if (this.activeTabName === 'gridState') {
        if (this.showOffice) {
          const stateName = CommonState.getNameByCode(this.priceStates, this.filter.state)
          const code = this.getOfficeCode(this.filter.branchId)
          return StrUtils.isEmpty(this.filter.branchId) ? StrUtils.substitute(fileName + '_{0}', stateName)
            : StrUtils.substitute('[{0}]{1}_{2}', code, fileName, stateName)
        }
        return fileName
      }
      const dateName = this.filter.dateFrom + this.$t('Pricing.StatEndDate') + this.filter.dateTo
      if (this.showOffice && !StrUtils.isEmpty(this.filter.branchId)) {
        return StrUtils.substitute('[{0}]{1}_{2}', this.getOfficeCode(this.filter.branchId), fileName, dateName)
      }
      return StrUtils.substitute(fileName + '_{0}', dateName)
    },
    getOfficeCode(value) {
      return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Office, 'officeId', value, 'code')
    },
    toReset() {
      this.filter.state = 0
      this.filter.branchId = 0
      this.filter.dateType = 'month'
      this.initPeriod(true)
      this.getGrid().rowData = []
    },
    changeOffice(p) {
      this.filter.branchId = p.value
      if (this.activeTabName !== 'gridPort') {
        this.getGrid().rowData = []
      }
    }
  }
}
</script>

<style lang="scss">
.price-air-stat{
  .el-form{
    display: flex;
    height: 28px;
    .el-form-item__content{
      width: 190px;
    }
  }
}
</style>
